// @flow
import React, { PureComponent } from 'react';

import {
  DropZoneStyled,
  DropPlaceHolder,
  OverlayWrap,
} from './ImageDrop.styled';

export type DroppedImage = {
  src: string,
  croppedSrc?: string,
  size: {
    width: number,
    height: number,
  },
  image: any,
  name: string,
};

type Props = {
  children: any,
  onLoadedImage: (image: DroppedImage) => void,
};

type State = {
  files: any[],
  dropzoneActive: boolean,
};

class ImageDrop extends PureComponent<Props, State> {
  state = {
    dropzoneActive: false,
  };

  onDragEnter = () => {
    this.setState({
      dropzoneActive: true,
    });
  };

  onDragLeave = () => {
    this.setState({
      dropzoneActive: false,
    });
  };

  onDrop = files => {
    this.setState({
      dropzoneActive: false,
    });

    if (files.length > 0) {
      const { onLoadedImage } = this.props;
      const [file] = files;

      const reader = new FileReader();
      reader.onload = () => {
        const imageUrl = reader.result;
        if (onLoadedImage && typeof imageUrl === 'string') {
          const image = new Image();

          image.src = imageUrl;

          image.onload = () => {
            const size = { width: image.width, height: image.height };
            onLoadedImage({ src: imageUrl, size, name: file.name });
          };
        }
      };

      reader.readAsDataURL(file);
    }
  };

  render() {
    const { dropzoneActive } = this.state;
    const { children } = this.props;
    return (
      <DropZoneStyled
        disableClick
        onDrop={this.onDrop}
        onDragEnter={this.onDragEnter}
        onDragLeave={this.onDragLeave}
        accept="image/jpeg, image/png"
      >
        <div>{children}</div>
        <OverlayWrap isActive={dropzoneActive}>
          <DropPlaceHolder>DROP THE IMAGE</DropPlaceHolder>
        </OverlayWrap>
      </DropZoneStyled>
    );
  }
}

export default ImageDrop;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/ImageDrop/ImageDrop.js